import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { applyPolyfills, defineCustomElements } from '@volt/volt-extended-components/loader';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { navRouter } from './navigation';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={navRouter} />
    </Provider>
  </StrictMode>,
);

applyPolyfills().then(() => {
  defineCustomElements();
});
